// components/CTASection.js
import { motion } from 'framer-motion';

const CTASection = () => {
  // Variantes de animação
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 12,
        stiffness: 100
      }
    }
  };

  return (
    <section className="py-24 bg-[#0a0a0a] text-white">
      <div className="container mx-auto px-4 text-center">
        <motion.div
          className="max-w-3xl mx-auto"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <motion.h2
            className="text-3xl md:text-5xl font-extrabold mb-6 tracking-tight"
            variants={itemVariants}
          >
            Pronto para Transformar seu{' '}
            <span className="text-gray-400">
              Site em App?
            </span>
          </motion.h2>

          <motion.p
            className="text-lg md:text-xl max-w-2xl mx-auto mb-10 text-gray-400 font-light leading-relaxed"
            variants={itemVariants}
          >
            Comece agora mesmo e leve sua presença digital para o próximo nível com um aplicativo nativo e super rápido para seus usuários.
          </motion.p>

          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
            variants={itemVariants}
          >
            <a
              href="./login.html"
              className="px-8 py-3.5 bg-white text-gray-900 rounded-lg font-medium text-base transition-all duration-300 flex items-center justify-center gap-2 hover:bg-gray-100 hover:shadow-[inset_0_0_10px_rgba(0,0,0,0.05)] outline-none cursor-pointer"
            >
              Criar Aplicativo Agora
              <svg
                className="w-4 h-4 ml-1"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
              </svg>
            </a>

            <a
              href="#features"
              className="px-8 py-3.5 bg-transparent text-white border border-gray-800 rounded-lg font-medium text-base transition-all duration-300 flex items-center justify-center hover:bg-[#1a1a1a] hover:border-gray-700 outline-none cursor-pointer"
            >
              Saiba mais
            </a>
          </motion.div>

          <motion.div
            className="mt-12 flex flex-wrap justify-center gap-6 text-gray-500 text-sm font-light"
            variants={itemVariants}
          >
            <div className="flex items-center">
              <span className="mr-2 text-gray-400">✓</span>
              <span>Atualizações em tempo real</span>
            </div>
            <div className="flex items-center">
              <span className="mr-2 text-gray-400">✓</span>
              <span>Mais visibilidade no mercado</span>
            </div>
            <div className="flex items-center">
              <span className="mr-2 text-gray-400">✓</span>
              <span>Suporte especializado</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;